var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickethistoryicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_38_1",
    "data-name": "Component 38 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.504,
    height: 56.572,
    viewBox: "0 0 56.504 56.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M301.812,338.2c1.775-1.782,3.5-3.535,5.254-5.262.585-.566,1.159-1.476,2.107-1.1,1.009.4.783,1.465.783,2.33v14.812c0,1.649-.606,2.263-2.262,2.263h-15.22a4.265,4.265,0,0,1-.877-.054c-1.131-.241-1.442-1.035-.721-1.943a25.361,25.361,0,0,1,1.9-2c1.32-1.332,2.649-2.652,4.052-4.052a20.428,20.428,0,0,0-7.139-4.537,21.224,21.224,0,1,0,12.3,25.893,3.524,3.524,0,0,1,3.359-2.686,3.332,3.332,0,0,1,3.334,2.378,4.577,4.577,0,0,1-.037,2.466,27.121,27.121,0,0,1-22.221,19.467A28.094,28.094,0,0,1,254,363.8a28.393,28.393,0,0,1,22.464-33.282c.145-.028.292-.055.438-.082a28.6,28.6,0,0,1,24.5,7.442C301.5,337.961,301.592,338.026,301.812,338.2Z",
    transform: "translate(-253.473 -330.028)",
    fill: "#cec328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M286.58,362.316h6.648a3.567,3.567,0,0,1,3.858,3.252c.007.078.011.156.012.234a3.574,3.574,0,0,1-3.551,3.6c-.113,0-.227,0-.339-.014H283.27a3.539,3.539,0,0,1-3.857-3.832V355.5a3.553,3.553,0,0,1,3.291-3.794c.088-.006.176-.009.264-.009a3.56,3.56,0,0,1,3.523,3.6c0,.083,0,.167-.012.249v6.4A2.7,2.7,0,0,0,286.58,362.316Z",
    transform: "translate(-258.246 -334.018)",
    fill: "#cec328"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickethistoryicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/ticket.history.icon.9aaeb23b02a595c7f472962f3c5446da.svg";
export { ForwardRef as ReactComponent };